<template>
  <div class="loading-spinner"></div>
</template>

<style scoped>
@import "LoadingSpinner.css";
</style>
